'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

require('../../styles/sections/index-content.scss');

exports.default = (0, _themeSections.register)('index-content', {
  onLoad: function onLoad() {
    var trigger = new Event('lazy:reload');
    document.dispatchEvent(trigger);
  },
  onUnload: function onUnload() {}
});